import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useBannerInView } from '@client/hooks/useBannerInView'
import { useBannerViewAnalytics } from '@client/hooks/useBannerViewAnalytics'
import { getBanners } from '@client/selectors/appSelectors'
import { fetchBanners } from '@client/store/App/appActions'
import { Lang } from '@client/types'
import { getBannersByPlatform } from '@client/utils/getBannersByPlatform'
import { getRandomInt } from '@client/utils/getRandomInt'
import { sendBannerClickAnalytics } from '@client/utils/sendBannerClickAnalytics'

import styles from './DFPBanner.module.css'

export const DFPBanner = ({ lang }: { lang: Lang }) => {
  const bannersData = useSelector(getBanners)

  const dispatch = useDispatch()

  const { ref, inView } = useBannerInView()

  const position = 'aside'

  const banners = getBannersByPlatform(bannersData?.aside)
  const random = getRandomInt(0, banners?.length - 1)
  const banner = banners?.[random]

  useEffect(() => {
    if (!bannersData) {
      dispatch(fetchBanners.request({ lang }))
    }
  }, [bannersData, dispatch, lang])

  useBannerViewAnalytics({
    inView,
    banner,
    position,
    dispatch
  })

  const handleBannerClick = () => {
    sendBannerClickAnalytics(banner, position, dispatch)
  }

  if (!banner) {
    return null
  }

  return (
    <div className={styles.root}>
      <div className={styles.body}>
        {banner && (
          <a
            className={styles.link}
            href={banner.url}
            target="_blank"
            rel="noreferrer"
            ref={ref}
            onClick={handleBannerClick}
          >
            <img
              className={styles.image}
              src={banner.desktop}
              alt={banner.alt}
            />
          </a>
        )}
      </div>
    </div>
  )
}
